<template>
  <container>
    <div class="w-full lg:w-10/12 mx-auto flex flex-col mt-16">
      <title-component title="Descubra cuidados personalizados para você!"
                       sub-title="Conheça as especialidades da Dra. Bianca Eluisa e transforme sua saúde."/>
      <div class="flex justify-center items-center">
<!--        <div
            class="w-full pb-6 lg:w-5/12 flex flex-col justify-center items-center rounded-md mb-4 md:mb-0 bg-gradient-to-r from-[#00BADE] to-[#00DFDE] text-white shadow-lg gap-3"
        >
          <div class="flex justify-center items-center mt-8 rounded-md">
            <img src="../../public/pilates.jpeg" width="849" height="1280" alt="Pilates" class="rounded-md w-[300px] h-[400px]" loading="lazy">
          </div>
          <h2 class="h-12 text-xl px-2 font-bold text-center lg:my-4">Pilates com aparelhos, solo e acessórios</h2>
        </div>

        <div
            class="pb-6 w-full lg:w-5/12 flex flex-col justify-center items-center rounded-md mb-4 md:mb-0 bg-gradient-to-r from-[#00BADE] to-[#00DFDE] text-white shadow-lg  gap-3"
        >
          <div class="flex justify-center items-center mt-8 rounded-md">
            <img src="../../public/drenagem.jpeg" width="300" height="400" alt="Pilates" class="rounded-md" loading="lazy">
          </div>
          <h2 class="h-12 text-xl px-2 font-bold text-center lg:my-4">Massagem Drenante e Drenagem Linfática </h2>
        </div>-->
        <div class="w-full lg:w-[600px] overflow-hidden bg-white rounded-lg shadow-xl shadow-slate-200">
          <!-- Body-->
          <div class="p-12">
            <header class="flex gap-4">
              <div class="relative inline-flex items-center justify-center w-28 h-28 text-white rounded-full">
                <img src="../../public/diastase.webp" alt="Tratamento de diástase" width="300" height="300"
                     class="rounded-full" loading="lazy">
              </div>
              <div>
                <h3 class="text-2xl font-bold text-slate-900">Dra. Bianca Eluisa</h3>
                <p class="text-lg text-slate-600">Fisioterapeuta</p>
                <div class="flex w-full justify-center ml-3 mt-4">
                  <ul class="text-black list-disc">
                    <li>Pilates com aparelhos, solo e acessórios</li>
                    <li>Drenagem Linfática</li>
                    <li>Tratamento de diástase</li>
                  </ul>
                </div>
              </div>
            </header>
          </div>
        </div>
      </div>
      <div class="w-full mt-12 flex justify-center items-center">
        <primary-button title="Agende sua pré consulta gratuita"/>
      </div>
    </div>
  </container>

</template>
<script>
import Container from "@/components/partials/Container.vue";
import TitleComponent from "@/components/TitleComponent.vue";
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";

export default {
  name: 'SpecialityComponent',
  components: {PrimaryButton, TitleComponent, Container: Container}
}
</script>